import { types } from 'mobx-state-tree';

import { transactionDescriptionTranslation } from './TransactionStore';

export default types
  .model('TransactionSummary', {
    id: types.number,
    user: types.string,
    description: types.string,
    is_successful: types.boolean,
    is_void: types.maybe(types.boolean),
    amount: types.number,
    created_at: types.string,
    logo_type: types.maybe(types.string),
    logo: types.maybeNull(types.string),
    human_label: types.maybeNull(types.string),
    result_label: types.maybeNull(types.string),
    result: types.maybeNull(types.string),
  })
  .views(self => ({
    get human_description() {
      return transactionDescriptionTranslation[self.description] || `No description (${self.description})`;
    },
    get logo_src() {
      return self.logo_type === 'bank_institution' ? `data:image/jpeg;base64,${self.logo}` : self.logo;
    },
    get status() {
      if (self.is_successful) {
        return self.is_void ? 'void' : 'successful';
      }
      return 'failed';
    },
  }));
